module.exports = __webpack_public_path__ + "img/icon04.9e0e9308.png";